import React, { useState, useEffect, useRef } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { Link } from "react-router-dom";
import { DatePicker } from "antd";
import Select from "react-select";
import { Calendar } from "feather-icons-react/build/IconComponents";
import {
  getSupplierList,
  getTaxList,
  getDiscountList,
  getUnitList,
  getDiscountbyguid,
} from "../../../services/MasterApiServices";
import PlusCircle from "feather-icons-react/build/IconComponents/PlusCircle";
import { getProductList } from "../../../services/MasterApiServices";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelector } from "react-redux";
import { PurchaseClass } from "../../../core/json/Purchase";
import { PurchaseDetailClass } from "../../../core/json/PurchaseDetail";
import toast from "react-hot-toast";
import {
  addEditPurchase,
  getPurchaseByTransType,
} from "../../../services/PurchaseApiService";
import SupplierModal from "../../master/modal/SupplierModal";
import { ProductClass } from "../../../core/json/Product";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import { DiscountClass } from "../../../core/json/Discount";
import { TaxClass } from "../../../core/json/TaxClass";
import { useDispatch } from "react-redux";
import {
  fetchUnit,
  fetchProduct,
  fetchTax,
  fetchSupplier,
  fetchSettings,
} from "../../../redux/userSetting";
import { FinancialYear } from "../../../core/json/FinancialYear";
import {
  fetchNextEntryNumber,
  registerEntryNumber,
} from "../../../core/utils/entryNumberUtils";

const PurchaseOrderModal = ({
  mode,
  data,
  handleClose,
  handleRefresh,
  existingEntries,
}) => {
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    watch,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      date: dayjs().format("YYYY-MM-DD"),
      deliveryDate: dayjs().format("YYYY-MM-DD"),
      invoiceDate: dayjs().format("YYYY-MM-DD"),
      duedate: dayjs().format("YYYY-MM-DD"),
      addition: 0,
      subtraction: 0,
      round: 0,
      paymentType: 0,
      referenceType: 0,
    },
    mode: "onBlur",
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  useEffect(() => {
    dispatch(fetchUnit());
    dispatch(fetchProduct(branch));
    dispatch(fetchTax());
    dispatch(fetchSettings(branch));
    const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
    const currfmt = match ? match[0]?.length - 1 : 0;
    setDecimalPoints(currfmt);
    dispatch(fetchSupplier());
  }, []);
  const dispatch = useDispatch();

  useEffect(() => {}, []);
  const [products, setProducts] = useState([]);
  const [discountList, setdiscountList] = useState([]);
  const [decimalpoints, setDecimalPoints] = useState(2);
  const [taxData, setTaxData] = useState([]);
  const [discountData, setdiscountData] = useState([]);
  const [unitData, setunitData] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  const { userId } = useSelector((state) => state.userauth);
  const { branch } = useSelector((state) => state.branchlist);
  const [isRowAdded, setIsRowAdded] = useState(false);
  const [printAfterSubmit, setPrintAfterSubmit] = useState(false);

  const { productList, unitList, taxList, supplierList, settingList } =
    useSelector((state) => state.usersetting);

  const paymentType = [
    { value: 0, label: "Cash" },
    { value: 1, label: "Card" },
    { value: 2, label: "Bank" },
    { value: 3, label: "Credit" },
    { value: 4, label: "UPI" },
  ];
  const referenceType = [
    { value: 0, label: "Direct" },
    //{ value: 1, label: "Order" },
    //{ value: 2, label: "Goods Receipt" },
  ];

  function handleRemove(index) {
    if (fields.length > 1) {
      remove(index);
    } else {
      toast.error("At least one product entry is required");
    }
  }
  const { branchsettings } = useSelector((state) => state.settings);
  const { companyInfolist } = useSelector((state) => state.companyInfo);
  const selectRef = useRef(null);
  const focusProduct = () => {
    setTimeout(() => {
      if (selectRef.current) {
        selectRef.current.focus();
      }
    }, 0);
  };

  useEffect(() => {
    focusProduct();
  }, []);

  //Calculations ---------------
  const safeNumber = (value, defaultValue = 0) => {
    if (value === null || value === undefined || value === "") {
      return defaultValue;
    }
    const num = Number(value);
    return isNaN(num) ? defaultValue : num;
  };

  let totalGross = 0;
  let totalDiscount = 0;
  let totalTax = 0;
  let totalNet = 0;

  fields.forEach((field, index) => {
    const quantity = watch(`items[${index}].quantity`, 0);
    const price = watch(`items[${index}].price`, 0);
    const discount = watch(`items[${index}].discountPercentage`, 0);
    const tax = watch(`items[${index}].taxPercentage`, 0);

    const grossTl = price * quantity || 0;
    const discountAmt = (grossTl * discount) / 100 || 0;
    const amountBeforeTax = grossTl - discountAmt || 0;
    const taxAmount = (amountBeforeTax * tax) / 100 || 0;
    const netTotal = amountBeforeTax + taxAmount || 0;

    setValue(`items[${index}].gross`, grossTl?.toFixed(decimalpoints));
    setValue(
      `items[${index}].discountAmount`,
      discountAmt?.toFixed(decimalpoints)
    );
    setValue(`items[${index}].taxAmount`, taxAmount?.toFixed(decimalpoints));
    setValue(`items[${index}].netTotal`, netTotal?.toFixed(decimalpoints));

    // Add to totalGross
    totalGross += grossTl;
    totalDiscount += discountAmt;
    totalTax += taxAmount;
    totalNet += netTotal;
  });
  //Final calculations on addition ,discount and round
  const addition = Number(watch(`addition`, 0));
  const subtraction = Number(watch(`subtraction`, 0));
  const round = Number(watch(`round`, 0));

  totalNet += safeNumber(addition);
  totalNet -= safeNumber(subtraction);
  totalNet -= safeNumber(round);
  totalDiscount = totalDiscount + safeNumber(subtraction);
  const handleTaxList = async () => {
    try {
      const formattedTax = taxList?.map((tax) => ({
        label: tax.percentage,
        value: tax.percentage,
        guid: tax.guid,
      }));
      setTaxData(formattedTax);
    } catch (error) {
      console.error(
        "Error fetching tax",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
  const handleDiscountList = async () => {
    try {
      const response = await getDiscountList();
      setdiscountList(response);
      const formattedDiscount = response?.map((discount) => ({
        label: discount.percentage,
        value: discount.percentage,
        guid: discount.guid,
      }));
      setdiscountData(formattedDiscount);
    } catch (error) {
      console.error(
        "Error fetching discount",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleEachProductfetch = async (selectedOption, index) => {
    setValue(`items[${index}].product`, selectedOption.value);

    try {
      const productData = await getSingleProduct(selectedOption.value);

      setValue(`items[${index}].code`, productData?.code || 0);
      setValue(`items[${index}].hsnCode`, productData?.hsnCode || 0);
      setValue(`items[${index}].unit`, productData?.unit.guid || 0);
      setValue(`items[${index}].price`, productData?.cost || 0);
    } catch (error) {
      console.error(
        "Error fetching product by GUID:",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  async function getSingleProduct(guid) {
    try {
      const filteredData = productList?.filter(
        (product) => product.guid === guid
      );
      return filteredData[0];
    } catch (error) {
      console.error("Error fetching products", error);
    }
  }

  const handleSupplierList = async () => {
    try {
      // const response = await getSupplierList();
      const formattedSuppliers = supplierList?.map((supplier) => ({
        label: supplier.name,
        value: supplier.guid,
        address1: supplier.address1,
        address2: supplier.address2,
      }));
      console.log(formattedSuppliers, "formattedSuppliers");
      setSupplierData(formattedSuppliers);
    } catch (error) {
      console.error("Error fetching suppliers", error);
    }
  };

  // Fetch purchase invoices data
  const handleEntryNo = async () => {
    try {
      const newEntryNo = await fetchNextEntryNumber({
        prefix: "PO",
        branchGuid: branch?.guid,
        cachedRecords: existingEntries,
        fetcher: () => getPurchaseByTransType(branch, 0),
      });
      setValue(`entrynumber`, newEntryNo);
    } catch (error) {
      console.error("Failed to fetch purchase orders", error);
    }
  };
  const settings = useSelector((state) => state.userSetting?.settings || {});
  const disableTaxInSale = settings?.disableTaxInSale ?? true; // Default to false if not set
  const isTaxEnabled = disableTaxInSale;


  const handlePrint = () => {
    printA4Function(); // Only A4 print allowed
  };

  function resetmodal() {
    if (mode === "edit" && data) {
      const mappedItems = data?.purchaseDetails?.map((detail) => ({
        product: detail?.product?.guid || null,
        code: detail?.product?.code || "",
        hsnCode: detail?.product?.hsnCode || "",
        batch: detail.batch || "",
        expiry: dayjs(detail.expiry),
        unit: detail.unit?.guid || null,
        quantity: detail.quantity || 0,
        price: detail.price || 0,
        mrp: detail.mrp || 0,
        foc: detail.foc || 0,
        discountPercentage: detail.discount?.percentage || null,
        discountAmount: detail.discountAmount || 0,
        taxPercentage: detail.tax?.percentage || null,
        gross: detail.gross || 0,
        taxAmount: detail.taxAmount || 0,
        netTotal: detail.netTotal || 0,
      }));

      reset({
        entrynumber: data.entrynumber || "",
        remarks: data.remarks || "",
        refNo: data.refNo || "",
        shipmentNo: data.shipmentNo || "",
        shipmentTerms: data.shipmentTerms || "",
        invoiceNo: data.invoiceNo || "",
        addition: data.addition || 0,
        subtraction: data.discount || 0,
        round: data.roundOff || 0,
        grossTotal: data.grossTotal || 0,
        discountTotal: data.discountTotal || 0,
        taxTotal: data.taxTotal || 0,
        netTotal: data.netTotal || 0,
        paymentType: data.purchasePaymentType || 0,
        referenceType: data.referenceType || 0,
        supplier: data.supplier?.guid || null,
        date: dayjs(data.date) || dayjs(),
        invoiceDate: dayjs(data.invoiceDate) || dayjs(),
        duedate: dayjs(data.duedate) || dayjs(),
        items: mappedItems?.length > 0 ? mappedItems : [getBlankItem()],
      });
    } else {
      reset({
        remarks: "",
        refNo: "",
        shipmentNo: "",
        shipmentTerms: "",
        invoiceNo: "",
        addition: 0,
        subtraction: 0,
        round: 0,
        grossTotal: 0,
        discountTotal: 0,
        taxTotal: 0,
        netTotal: 0,
        paymentType: 0,
        referenceType: 0,
        supplier: null,
        date: dayjs(),
        invoiceDate: dayjs(),
        duedate: dayjs(),
        items: [getBlankItem()],
      });
      handleEntryNo();
    }
  }
  function getBlankItem() {
    return {
      product: null,
      code: "",
      hsnCode: "",
      batch: "",
      expiry: dayjs(),
      unit: null,
      quantity: 0,
      price: 0,
      mrp: 0,
      foc: 0,
      discountPercentage: null,
      discountAmount: 0,
      taxPercentage: null,
      gross: 0,
      taxAmount: 0,
      netTotal: 0,
    };
  }

  useEffect(() => {
    handleSupplierList();
  }, [supplierList]);

  // useEffect(() => {
  //   resetmodal();
  // }, [data, setValue]);

  useEffect(() => {
    if (mode === "edit" && Object.keys(data).length > 0) {
      resetmodal(); // Only for editing existing data
    }
  }, [data]);

  useEffect(() => {
    if (mode === "add") {
      handleEntryNo();
      if (!isRowAdded && fields?.length === 0) {
        handleAddRow();
        setIsRowAdded(true);
      }
    }

    handleUnitList();
    handleDiscountList();
    dispatch(fetchSettings(branch));
    const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
    const currfmt = match ? match[0]?.length - 1 : 0;
    setDecimalPoints(currfmt);
  }, []);

  // Re-map whenever the redux lists arrive so the dropdowns are not stuck
  // waiting on whatever else the mount effect kicked off.
  useEffect(() => {
    handleProductsList();
  }, [productList]);

  useEffect(() => {
    handleTaxList();
  }, [taxList]);

  const handleUnitList = async () => {
    try {
      const response = await getUnitList();
      const formattedUnit = response?.map((unit) => ({
        label: unit.name,
        value: unit.guid,
      }));
      setunitData(formattedUnit);
    } catch (error) {
      console.error(
        "Error fetching unit",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
  const handleProductsList = async () => {
    try {
      const formattedProducts = productList?.map((product) => ({
        label: product.name,
        value: product.guid,
      }));
      setProducts(formattedProducts);
    } catch (error) {
      console.error(
        "Error fetching products",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleAddRow = () => {
    append({
      batch: "0",
      code: "0",
      discountAmount: "0.0",
      discountPercentage: 0.0,
      expiry: dayjs().format("YYYY-MM-DD"),
      foc: "0.0",
      gross: "0.0",
      hsnCode: 0,
      mrp: "0.0",
      netTotal: "0.0",
      price: "0.0",
      quantity: "0",
      taxAmount: "0.0",
      taxPercentage: 0,
      unit: "",
      product: null,
    });
    focusProduct();
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const form = e.target.form; // Get form element
      const index = Array.from(form.elements).indexOf(e.target); // Get current element index
      if (index !== -1 && form.elements[index + 1]) {
        form.elements[index + 1].focus(); // Focus the next input field
      }
    }
  };
  const handleFormSubmit = async (formdata) => {
    const objPurchase = new PurchaseClass();
    const objfinance = new FinancialYear();
    if (mode === "edit") {
      objPurchase.guid = data.guid;
      objPurchase.id = data.id;
    }
    objPurchase.branch = branch;
    objPurchase.date = formdata.date
      ? dayjs(formdata.date).format("YYYY-MM-DDTHH:mm:ss")
      : dayjs().format("YYYY-MM-DD");
    objPurchase.purchasePaymentType = formdata.paymentType;
    objPurchase.purchaseTransType = 0;
    objPurchase.supplier = supplierList?.find(
      (e) => e.guid == formdata.supplier
    );
    console.log("supplier", objPurchase.supplier);
    objPurchase.updatedUser = `{${userId?.id}}`;
    objPurchase.invoiceDate = formdata.invoiceDate
      ? dayjs(formdata.invoiceDate).format("YYYY-MM-DDTHH:mm:ss")
      : dayjs().format("YYYY-MM-DD");
    objPurchase.invoiceNo = formdata.invoiceNo || "0";
    objPurchase.refNo = formdata.refNo || "0";
    objPurchase.shipmentNo = formdata.shipmentNo || "0";
    objPurchase.shipmentTerms = formdata.shipmentTerms || "";
    objPurchase.remarks = formdata.remarks || "";
    objPurchase.addition = formdata.addition || "0.0";
    objPurchase.discount = formdata.subtraction || "0.0";
    objPurchase.roundOff = formdata.round || "0.0";
    objPurchase.grossTotal = totalGross || 0;
    objPurchase.discountTotal = totalDiscount || 0.0;
    objPurchase.taxTotal = totalTax || 0.0;
    objPurchase.netTotal = totalNet || 0.0;
    objPurchase.referenceType = formdata.referenceType || 0;
    objPurchase.entrynumber = formdata.entrynumber || 0;
    objPurchase.duedate = formdata.duedate
      ? dayjs(formdata.duedate).format("YYYY-MM-DDTHH:mm:ss")
      : dayjs().format("YYYY-MM-DD");

    objfinance.id = branchsettings?.defaultFinancialYearID;
    objPurchase.financialYear = objfinance;
    objPurchase.Company = companyInfolist[0];

    const detailObj = formdata?.items?.map((e) => {
      const defaultDiscountobj = new DiscountClass();
      const defaultTaxobj = new TaxClass();

      let product;
      const productValue = e.product || e.product.value;
      console.log("productValue", productValue);
      product = productList?.find((item) => item.guid == productValue);
      const unit = unitList?.find((item) => item.guid == e.unit);
      const discountValue = discountData?.find(
        (discount) => discount.value === e.discountPercentage
      );
      const discount = discountValue
        ? discountList?.find((item) => item.guid == discountValue.guid)
        : defaultDiscountobj;
      const taxValue = taxData?.find((tax) => tax.value === e.taxPercentage);
      const tax = taxValue
        ? taxList?.find((item) => item.guid == taxValue.guid)
        : defaultTaxobj;

      const expiry = e.expiry
        ? dayjs(e.expiry).format("YYYY-MM-DDTHH:mm:ss")
        : dayjs().format("YYYY-MM-DDTHH:mm:ss");

      const detailObj = {
        product,
        unit,
        batch: e.batch,
        expiry,
        quantity: e.quantity,
        price: e.price,
        mrp: e.mrp,
        foc: e.foc,
        taxAmount: e.taxAmount,
        grossAmount: e.gross,
        netAmount: e.netTotal,
        discountAmount: e.discountAmount,
        discount,
        tax,
      };
      return detailObj;
    });
    objPurchase.purchaseDetails = detailObj;

    try {
      console.log(objPurchase, "-------------------objPurchase");
      const response = await addEditPurchase(objPurchase);
      if (response) {
        registerEntryNumber(branch?.guid, objPurchase.entrynumber);
        toast.success("Success");
        handleRefresh(); // Refresh the list
        handleClose(); // Close the modal

        if (printAfterSubmit) {
          printA4Function(); // 👈 only called if user clicked "Save & Print"
          setPrintAfterSubmit(false); // reset flag
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.Message || "something went wrong");
      console.error(
        "Error handling :",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
//   const printA4Function = async () => {
//     const form = document.getElementById("invoice-content");

//     if (!form) {
//       console.error("Element with ID 'invoice-content' not found.");
//       return;
//     }

//     const company = companyInfolist.length > 0 ? companyInfolist[0] : {}; // Assuming single company info

//     // Extract company details
//     const companyName = company.name || "Company Name";
//     const companyAddress1 = company.address1 || "";
//     const companyAddress2 = company.address2 || "";
//     const companyAddress3 = company.address3 || "";
//     const companyPhone = company.phone || "";
//     const companyVAT = company.tin || "";
//     // Extract values from form inputs

//     const entryNumber =
//       form.querySelector("input[name='entrynumber']")?.value || "";

//     const dateValue = watch("date") || new Date().toISOString();
//     const date = new Date(dateValue).toLocaleDateString("en-GB"); // Format date as DD/MM/YYYY
//     const deliveryDate = new Date(watch("deliveryDate")).toLocaleDateString(
//       "en-GB"
//     );
//     const invDateValue = watch("invdate") || new Date().toISOString();
//     const invoiceDate = new Date(invDateValue).toISOString();
//     const supplierGuid = watch("supplier");
//     const supplierObj =
//       supplierList.find((sup) => sup.guid === supplierGuid) || {};
//     const supplierName = supplierObj.name || supplierObj.ledger || "N/A";
//     const supplierAddress1 = supplierObj.address1 || "";
//     const supplierMobile = supplierObj.mobile || "";
//     const supplierPhone = supplierObj.phone || "";
//     const fields = watch("items") || [];
//     const selectedPaymentValue = watch("paymentType");
//     const selectedPayment = paymentType.find(
//       (p) => p.value === selectedPaymentValue
//     );
//     const paymentLabel = selectedPayment?.label || "N/A";

//     const discount = fields.reduce(
//       (sum, item) => sum + (parseFloat(item.discountAmount) || 0),
//       0
//     );
//     const taxTotal = fields.reduce(
//       (sum, item) => sum + (parseFloat(item.taxAmount) || 0),
//       0
//     );
//     const netTotal = fields.reduce(
//       (sum, item) => sum + (parseFloat(item.netTotal) || 0),
//       0
//     );
//     const supplierDetailsHTML = `
//   <strong>${supplierName}</strong><br>
//   ${supplierAddress1 ? `${supplierAddress1}<br>` : ""}
//   ${supplierObj.address2 ? `${supplierObj.address2}<br>` : ""}
//   ${supplierObj.address3 ? `${supplierObj.address3}<br>` : ""}
//   ${supplierMobile ? `Mobile : ${supplierMobile}<br>` : ""}
//   ${supplierPhone ? `Phone : ${supplierPhone}<br>` : ""}
//   ${companyVAT ? `VAT No / TRN : ${companyVAT}<br>` : ""}
// `;
//     // Store the totals in React Hook Form
//     setValue("discount", discount.toFixed(2));
//     setValue("taxTotal", taxTotal.toFixed(2));
//     setValue("netTotal", netTotal.toFixed(2));

//     console.log({ totalDiscount, totalTax, totalNet });

//     // Extract table data

//     const tableRows = Array.from(form.querySelectorAll("table tbody tr")).map(
//       (row) => {
//         // Query the react-select component for the current row
//         const selectContainer1 = row?.querySelector(".css-b62m3t-container");
//         const selectContainer = selectContainer1?.querySelector(
//           ".react-select__control"
//         );
//         const selectContainer3 = selectContainer?.querySelector(
//           ".react-select__value-container"
//         );
//         const selectedValueDiv = selectContainer3?.querySelector(
//           ".react-select__single-value"
//         );

//         // Extract the text or value of the selected option
//         const selectedValue = selectedValueDiv?.textContent || "N/A";

//         //   // Extract other values from the row (quantity, rate, total)
//         return {
//           description: selectedValue,
//           code: row.querySelector("td:nth-child(2) input")?.value?.trim() || "",
//           qty:
//             parseInt(
//               row.querySelector("td:nth-child(4) input")?.value?.trim()
//             ) || 0,
//           rate:
//             parseFloat(
//               row.querySelector("td:nth-child(5) input")?.value?.trim()
//             ) || 0.0,
//           total:
//             parseFloat(
//               row.querySelector("td:nth-child(10) input")?.value?.trim()
//             ) || 0.0,
//           tax:
//             parseFloat(
//               row.querySelector("td:nth-child(12) input")?.value?.trim()
//             ) || 0.0,
//           discount:
//             parseFloat(
//               row.querySelector("td:nth-child(9) input")?.value?.trim()
//             ) || 0.0,
//         };
//       }
//     );

//     // const tableRows = Array.from(form.querySelectorAll("table tbody tr")).map((row) => {
//     //   const selectContainer1 = row?.querySelector(".css-b62m3t-container");
//     //   const selectContainer = selectContainer1?.querySelector(".react-select__control");
//     //   const selectContainer3 = selectContainer?.querySelector(".react-select__value-container");
//     //   const selectedValueDiv = selectContainer3?.querySelector('.react-select__single-value');
//     //   const selectedValue = selectedValueDiv?.textContent || "N/A";

//     //   Array.from(document.querySelectorAll("table tbody tr")).forEach((tr, idx) => {
//     //   console.log(`Row ${idx + 1}:`, [...tr.children].map((td, i) => `(${i + 1}) ${td.textContent.trim()}`));
//     // });

//     //   return {
//     //     description: selectedValue,
//     //     code: row.querySelector("td:nth-child(2) input")?.value?.trim() || "",
//     //     qty: parseInt(row.querySelector("td:nth-child(7) input")?.value?.trim()) || 0,
//     //     rate: parseFloat(row.querySelector("td:nth-child(8) input")?.value?.trim()) || 0.00,
//     //     discount: parseFloat(row.querySelector("td:nth-child(10) input")?.value?.trim()) || 0.00,
//     //     tax: isTaxEnabled
//     //       ? parseFloat(row.querySelector("td:nth-child(15) input")?.value?.trim()) || 0.00
//     //       : 0.00,
//     //     total: isTaxEnabled
//     //       ? parseFloat(row.querySelector("td:nth-child(16) input")?.value?.trim()) || 0.00
//     //       : parseFloat(row.querySelector("td:nth-child(14) input")?.value?.trim()) || 0.00,
//     //   };
//     // });

//     console.log(tableRows, "lkkk");

//     // const qrData = `Company: ${companyName}\nDate: ${date}\nDelivery Date: ${deliveryDate}\nNet Total: ${netTotal.toFixed(2)}`;

//     //   const qrCodeUrl = await QRCode.toDataURL(qrData);

//     // const fatooraQRData = generateFatooraQR(companyName, companyVAT, invoiceDate, netTotal.toFixed(2), taxTotal.toFixed(2));
//     // const qrCodeUrl = await QRCode.toDataURL(fatooraQRData);

//     // Generate printable content
//     // const printableContent = `
//     //   <html>
//     //     <head>
//     //       <title>Invoice</title>
//     //       <style>
//     //         body { font-family: Arial, sans-serif; padding: 20px; }
//     //         table { width: 100%; border-collapse: collapse; margin-top: 10px; }
//     //         .header { text-align: center; margin-bottom: 20px; }
//     //         .qr-code { text-align: center; margin-top: 20px;}
//     //         th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
//     //         .text-right { text-align: right; }
//     //         .totals-table { width: 100%; margin-top: 20px; border-collapse: collapse; }
//     //         .totals-table td { border: none; padding: 5px; font-weight: bold; }
//     //         .totals-table .label { text-align: right; width: 80%; }
//     //         .totals-table .value { text-align: right; width: 20%; }
//     //         @media print {
//     //           body { margin: 0; }
//     //         }
//     //       </style>
//     //     </head>
//     //     <body>

//     //      <div class="header">
//     //         <h2>${companyName}</h2>
//     //         <p>${companyAddress1}, ${companyAddress2}, ${companyAddress3}</p>
//     //         <p>Phone: ${companyPhone}</p>
//     //       </div>

//     //       <p><strong>Entry No:</strong> ${entryNumber}</p>
//     //       <p><strong>Date:</strong> ${date}</p>
//     //       <p><strong>Delivery Date:</strong> ${deliveryDate}</p>
//     //       <p><strong>Customer Name:</strong> ${customerName}</p>
//     //       <p><strong>Contact Number:</strong> ${contactNumber}</p>

//     //       <table>
//     //         <thead>
//     //           <tr>
//     //             <th>Description</th>
//     //             <th>Rate</th>
//     //             <th>Qty</th>
//     //             <th>Total</th>
//     //           </tr>
//     //         </thead>
//     //         <tbody>
//     //           ${tableRows
//     //             .map(
//     //               (row) => `
//     //             <tr>
//     //               <td>${row.description}</td>
//     //               <td class="text-right">${row.rate.toFixed(2)}</td>
//     //               <td class="text-right">${row.qty}</td>
//     //               <td class="text-right">${row.total.toFixed(2)}</td>
//     //             </tr>
//     //           `
//     //             )
//     //             .join("")}
//     //         </tbody>
//     //       </table>

//     //       <table class="totals-table">
//     //         <tr>
//     //           <td class="label">Discount:</td>
//     //           <td class="value">${discount}</td>
//     //         </tr>
//     //         <tr>
//     //           <td class="label">Tax Total:</td>
//     //           <td class="value">${taxTotal}</td>
//     //         </tr>
//     //         <tr>
//     //           <td class="label">Net Total:</td>
//     //           <td class="value">${netTotal}</td>
//     //         </tr>
//     //       </table>
//     //     </body>
//     //   </html>
//     // `;

//     const printableContent = `
//   <html>
//     <head>
     
//       <style>
//        * { box-sizing: border-box; }
//         html, body {
//           height: 100%;
//           margin: 0;
//           padding: 20px;
//           font-family: Arial, sans-serif;
//           font-size: 12px;
//         }

//         .container {
//           display: flex;
//           flex-direction: column;
//           height: 100%;
//         }
//         table { width: 100%; border-collapse: collapse; margin-top: 10px; }
//         .header { text-align: center; margin-bottom: 10px; }
//         th, td { border: 1px solid #000; padding: 6px; font-size: 12px; text-align: center; }
//         .info-table { width: 100%; margin-bottom: 10px; }
//         .info-table .text-right {  text-align: left;       /* Make content left-aligned */
//   padding-left: 30%;  }
//         .info-table td { border: none; font-size: 12px; padding: 4px; text-align: left;  vertical-align: top; }
//         .info-table th { border: none; font-size: 13px; padding: 4px; text-align: left;  vertical-align: top; }
//         .totals-section
//          { display: flex;  justify-content: space-between; }
//              .content {
//           flex: 1;
//         } 
//         .additions { width: 60%; border: 1px solid #000; height: 100px; padding: 10px; font-size: 12px; }
//         .totals-table { width: 35%; border-collapse: collapse; }
//         .totals-table td { border: 1px solid #000; padding: 6px; font-size: 12px; text-align: right; }
//         .totals-table td.label { text-align: left; width: 70%; }
//            @media print {
//           html, body {
//             height: 100%;
//             margin: 0;
//             padding: 0;
//           }
//           .container {
//             padding: 20px;
//           }
//         }
//       </style>
//     </head>
//     <body>
//      <div class="container">
//       <div class="header">
//         <h2>${companyName}</h2>
        
//       <p>${companyAddress1}, ${companyAddress2}, ${companyAddress3}</p>
//         Email: ${company.email || "-"} | PH: ${companyPhone}
//       </div>

//    <table class="info-table">
//    <tr>
//     <th>
//       <strong>Supplier Details</strong>
//     </th>
//     </tr>
//   <tr>
//     <td>
//       ${supplierDetailsHTML}
//     </td>
//     <td class="text-right">
//       <strong>LPO No : </strong>${entryNumber}<br>
//       <strong>Date : </strong>${date}<br>
//       <strong>Invoice No : </strong>${
//         form.querySelector("input[name='invoiceNo']")?.value || ""
//       }<br>
//       <strong>Payment Mode : </strong>${paymentLabel}
//     </td>
//   </tr>
// </table>


//       <h3 style="text-align: center;">PURCHASE ORDER</h3>
//    <div class="content">
//       <table>
//         <thead>
//           <tr>
//             <th>S.No</th>
//             <th>Code</th>
//             <th>Particulars</th>
            
//             <th>Qty</th>
//             <th>Rate</th>
//             <th>Discount</th>
        
//             <th>Total</th>
//           </tr>
//         </thead>
//         <tbody>
//           ${tableRows
//             .map(
//               (row, index) => `
//             <tr>
//               <td>${index + 1}</td>
//               <td>${row.code || "-"}</td>
//               <td>${row.description}</td>
            
//               <td>${row.qty}</td>
//               <td>${row.rate.toFixed(2)}</td>
//               <td>${(row.discount || 0).toFixed(2)}</td>
            
//               <td>${(row.total || 0).toFixed(2)}</td>
//             </tr>`
//             )
//             .join("")}
//         </tbody>
//       </table>
//  </div>

// <hr style="margin-top: 20px; border: none; border-top: 2px solid #000; width: 100%;" />


//       <div class="totals-section">
//         <div class="additions">
//           <strong>Additions:</strong><br>
//           ${form.querySelector("textarea[name='additions']")?.value || ""}
//         </div>
//         <table class="totals-table">
//           <tr>
//             <td class="label">TOTAL:</td>
//             <td>${(netTotal + discount - taxTotal).toFixed(2)}</td>
//           </tr>
//           <tr>
//             <td class="label">DISCOUNT:</td>
//             <td>${discount.toFixed(2)}</td>
//           </tr>
     
//           <tr>
//             <td class="label">NET TOTAL:</td>
//             <td>${netTotal.toFixed(2)}</td>
//           </tr>
//         </table>
//       </div>
//          </div>
//     </body>
//   </html>
// `;

//     // Create an iframe for better printing
//     const iframe = document.createElement("iframe");
//     iframe.style.position = "absolute";
//     iframe.style.width = "0px";
//     iframe.style.height = "0px";
//     iframe.style.border = "none";
//     document.body.appendChild(iframe);

//     const doc = iframe.contentWindow.document;
//     doc.open();
//     doc.write(printableContent);
//     doc.close();

//     iframe.contentWindow.focus();
//     setTimeout(() => {
//       iframe.contentWindow.print();
//       iframe.contentWindow.onafterprint = () =>
//         document.body.removeChild(iframe);
//     }, 500);
//   };

    const printA4Function = async() => {
    const form = document.getElementById("invoice-content");
  
    if (!form) {
      console.error("Element with ID 'invoice-content' not found.");
      return;
    }

    const company = companyInfolist.length > 0 ? companyInfolist[0] : {}; // Assuming single company info

    // Extract company details
    const companyName = company.name || "Company Name";
    const companyAddress1 = company.address1 || "";
    const companyAddress2 = company.address2 || "";
    const companyAddress3 = company.address3 || "";
    const companyPhone = company.phone || "";
    const companyVAT = company.tin || "";
    // Extract values from form inputs
    

    
    
    
    const entryNumber = form.querySelector("input[name='entrynumber']")?.value || "";
   
    const dateValue = watch("date") || new Date().toISOString();
    const date = new Date(dateValue).toLocaleDateString("en-GB"); // Format date as DD/MM/YYYY
const deliveryDate = new Date(watch("deliveryDate")).toLocaleDateString("en-GB");
const invDateValue = watch("invdate") || new Date().toISOString();
  const invoiceDate = new Date(invDateValue).toISOString();
  const supplierGuid = watch("supplier");
const supplierObj = supplierList.find(sup => sup.guid === supplierGuid) || {};
const supplierName = supplierObj.name || supplierObj.ledger || "N/A";
const supplierAddress1 = supplierObj.address1 || "";
const supplierMobile = supplierObj.mobile || "";
    const fields = watch("items") || [];
const selectedPaymentValue = watch("paymentType");
const selectedPayment = paymentType.find(p => p.value === selectedPaymentValue);
const paymentLabel = selectedPayment?.label || "N/A";

const discount = fields.reduce((sum, item) => sum + (parseFloat(item.discountAmount) || 0), 0);
const taxTotal = fields.reduce((sum, item) => sum + (parseFloat(item.taxAmount) || 0), 0);
const  netTotal = fields.reduce((sum, item) => sum + (parseFloat(item.netTotal) || 0), 0);

// Store the totals in React Hook Form
setValue("discount", discount.toFixed(2));
setValue("taxTotal", taxTotal.toFixed(2));
setValue("netTotal", netTotal.toFixed(2));

console.log({ totalDiscount, totalTax, totalNet });

  
  // Extract table rows by data-label
  const tableRows = Array.from(form.querySelectorAll("tbody tr")).map((row, index) => ({
    description: row.querySelector('td[data-label="Description"]')?.innerText || "",
    code: row.querySelector('td[data-label="Item Code"] input')?.value || "",
    hsnCode: row.querySelector('td[data-label="HSN Code"] input')?.value || "",
    qty: parseFloat(row.querySelector('td[data-label="Quantity"] input')?.value || 0),
    rate: parseFloat(row.querySelector('td[data-label="Price"] input')?.value || 0),
    discount: parseFloat(row.querySelector('td[data-label="Discount Amount"] input')?.value || 0),
    tax: parseFloat(row.querySelector('td[data-label="Tax Amount"] input')?.value || 0),
    total: parseFloat(row.querySelector('td[data-label="Net Amount"] input')?.value || 0),
  }));


  // 🔹 Build headers dynamically
  let headerHtml = `
    <th>S.No</th>
    <th>Code</th>
    <th>Particulars</th>
    <th>Qty</th>
    <th>Rate</th>
    <th>Discount</th>
  `;

  if (branchsettings?.disableTaxInSale === false) {
    headerHtml += `<th>Tax</th>`;
  }

  headerHtml += `<th>Total</th>`;

  // 🔹 Build rows dynamically
  const rowsHtml = tableRows
    .map((row, i) => {
      let rowHtml = `
        <td>${i + 1}</td>
        <td>${row.code}</td>
        <td>${row.description}</td>
        <td>${row.qty}</td>
        <td>${row.rate.toFixed(2)}</td>
        <td>${row.discount.toFixed(2)}</td>
      `;

      if (branchsettings?.disableTaxInSale === false) {
        rowHtml += `<td>${row.tax.toFixed(2)}</td>`;
      }

      rowHtml += `<td>${row.total.toFixed(2)}</td>`;

      return `<tr>${rowHtml}</tr>`;
    })
    .join("");

  // 🔹 Add conditional tax total in footer
  let totalsHtml = `
    <tr>
      <td class="label">TOTAL:</td>
      <td>${(netTotal + discount - taxTotal).toFixed(2)}</td>
    </tr>
    <tr>
      <td class="label">TOTAL DISCOUNT:</td>
      <td>${discount.toFixed(2)}</td>
    </tr>
  `;

  if (branchsettings?.disableTaxInSale === false) {
    totalsHtml += `
      <tr>
        <td class="label">TOTAL TAX:</td>
        <td>${taxTotal.toFixed(2)}</td>
      </tr>
    `;
  }

  totalsHtml += `
    <tr>
      <td class="label">NET TOTAL:</td>
      <td>${netTotal.toFixed(2)}</td>
    </tr>
  `;


    const printableContent = `
  <html>
    <head>
     
      <style>
       * { box-sizing: border-box; }
        html, body {
          height: 100%;
          margin: 0;
          padding: 20px;
          font-family: Arial, sans-serif;
          font-size: 12px;
        }
@page {
  size: A4;
  margin: 20mm; /* adjust margins as needed */
  /* The following removes browser default headers/footers */
  @top-left {
    content: none;
  }
  @top-center {
    content: none;
  }
  @top-right {
    content: none;
  }
  @bottom-left {
    content: none;
  }
  @bottom-center {
    content: none;
  }
  @bottom-right {
    content: none;
  }
}

        .container {
          display: flex;
          flex-direction: column;
          height: 100%;
        }
        table { width: 100%; border-collapse: collapse; margin-top: 10px; }
        .header { text-align: center; margin-bottom: 10px; }
        th, td { border: 1px solid #000; padding: 6px; font-size: 12px; text-align: center; }
.info-table {
  width: 100%;
  table-layout: fixed;
}
.info-table td {
  font-size: 12px;
  padding: 4px;
  vertical-align: top;
  border: none;
}
.info-table td.left {
  width: 70%;
  text-align: left;
  word-break: break-word;
}
.info-table td.right {
  width: 30%;
  text-align: left;       /* 👈 important */
  white-space: nowrap;
  padding-left: 10px;     /* creates alignment gap */
}
.info-table td.right strong {
  display: inline-block;

}

        .totals-section
         { display: flex;  justify-content: space-between; }
             .content {
          flex: 1;
        } 
        .additions { width: 60%; border: 1px solid #000; height: 100px; padding: 10px; font-size: 12px; }
        .totals-table { width: 35%; border-collapse: collapse; }
        .totals-table td { border: 1px solid #000; padding: 6px; font-size: 12px; text-align: right; }
        .totals-table td.label { text-align: left; width: 70%; }
           @media print {
          html, body {
            height: 100%;
            margin: 0;
            padding: 0;
          }
          .container {
            padding: 20px;
          }
        }
      </style>
    </head>
    <body>
     <div class="container">
      <div class="header">
        <h2>${companyName}</h2>
        
      <p>${companyAddress1}, ${companyAddress2}, ${companyAddress3}</p>
        Email: ${company.email || "-"} | PH: ${companyPhone}
      </div>

<table class="info-table">
  <tr>
    <td class="left"><strong>Supplier : </strong> ${supplierName}</td>
    <td class="right">
      <strong>PO No : </strong> ${entryNumber}
    </td>
  </tr>
  <tr>
    <td class="left"><strong>Address : </strong> ${supplierAddress1}</td>
    <td class="right">
      <strong>Date : </strong> ${date}
    </td>
  </tr>
  <tr>
    <td class="left"><strong>Mobile No : </strong> ${supplierMobile}</td>
    <td class="right">
      <strong>Invoice No : </strong> ${form.querySelector("input[name='invoiceNo']")?.value || ""}
    </td>
  </tr>
  <tr>
    <td class="left"><strong>TIN : </strong> ${companyVAT}</td>
    <td class="right">
      <strong>Payment Mode : </strong> ${paymentLabel}
    </td>
  </tr>
</table>

      <h3 style="text-align: center;">PURCHASE ORDER</h3>
   <div class="content">
      <table>
        <thead>
          <tr>
            ${headerHtml}
          </tr>
        </thead>
       <tbody>
          ${rowsHtml}
            </tbody>
      </table>
 </div>

<hr style="margin-top: 20px; border: none; border-top: 2px solid #000; width: 100%;" />


      <div class="totals-section">
        <div class="additions">
          <strong>Additions:</strong><br>
          ${form.querySelector("textarea[name='additions']")?.value || ""}
        </div>
        <table class="totals-table">
          ${totalsHtml}
        </table>
      </div>
         </div>
    </body>
  </html>
`;

  
    // Create an iframe for better printing
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0px";
    iframe.style.height = "0px";
    iframe.style.border = "none";
    document.body.appendChild(iframe);
  
    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(printableContent);
    doc.close();
  
    iframe.contentWindow.focus();
    setTimeout(() => {
      iframe.contentWindow.print();
      iframe.contentWindow.onafterprint = () => document.body.removeChild(iframe);
    }, 500);
  };
  return (
    <>
      <style>{`
    /* Modal Fullscreen */


    /* Table Column Widths */
    .tablezinds th, .tablezinds td {
      padding: 4px 4px;
      font-size: 13px;
      vertical-align: middle;
    }

    .tablezinds th:nth-child(1), .tablezinds td:nth-child(1) { width: 26rem; }  /* Description */
    .tablezinds th:nth-child(2), .tablezinds td:nth-child(2) { width: 5rem; }  /* Item Code */
    .tablezinds th:nth-child(3), .tablezinds td:nth-child(3) { width: 4rem; }   /* Unit */
    .tablezinds th:nth-child(4), .tablezinds td:nth-child(4) { width: 6rem; }   /* Qty */
    .tablezinds th:nth-child(5), .tablezinds td:nth-child(5) { width: 8rem; }   /* Price */
    .tablezinds th:nth-child(6), .tablezinds td:nth-child(6) { width: 6rem; }   /* MRP */
    .tablezinds th:nth-child(7), .tablezinds td:nth-child(7) { width: 8rem; }   /* FOC */
    .tablezinds th:nth-child(8), .tablezinds td:nth-child(8) { width: 1rem; }   /* Gross */
    .tablezinds th:nth-child(9), .tablezinds td:nth-child(9) { width: 6rem; }   /* Discount % */
    .tablezinds th:nth-child(10), .tablezinds td:nth-child(10) { width: 1rem; } /* Discount Amt */
    .tablezinds th:nth-child(11), .tablezinds td:nth-child(11) { width: 6rem; } /* Tax % */
    .tablezinds th:nth-child(12), .tablezinds td:nth-child(12) { width: 8rem; } /* Tax Amt */
    .tablezinds th:nth-child(13), .tablezinds td:nth-child(13) { width: 2rem; } /* Net Amt */
    .tablezinds th:nth-child(14), .tablezinds td:nth-child(14) { width: 1%; } /* Actions */

    /* Inputs & Selects */




  `}</style>

      <div>
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
        >
          <div className="modal-dialog add-centered">
            <div className="modal-content">
              <div className="page-wrapper p-0 m-0">
                <div className="content p-0">
                  <div className="modal-header border-0 custom-modal-header">
                    <div className="page-title">
                      <h4>
                        {" "}
                        {mode === "edit"
                          ? "Edit Purchase Order"
                          : "Add Purchase Order"}
                      </h4>
                    </div>
                    <button
                      type="button"
                      className="close"
                      onClick={handleClose}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="card">
                    <div className="card-body">
                      <form
                        id="invoice-content"
                        onSubmit={handleSubmit(handleFormSubmit)}
                      >
                   <div className="row">

  {/* Row 1 */}
  <div className="col-md-4 col-sm-6 col-12">
    <div className="input-blocks d-flex align-items-center gap-2 mb-3">
      <label className="form-label" style={{ minWidth: "120px" }}>Date</label>
      <div className="input-groupicon calender-input w-100">
        <Calendar className="info-img" />
        <Controller
          control={control}
          name="date"
          render={({ field: { onChange, value } }) => (
            <DatePicker
              className="datetimepicker"
              value={value ? dayjs(value) : null}
              format="DD-MM-YYYY"
              onChange={(date) => onChange(date ? date.format("YYYY-MM-DD") : null)}
            />
          )}
        />
      </div>
    </div>
  </div>

  <div className="col-md-4 col-sm-6 col-12">
    <div className="input-blocks d-flex align-items-center gap-2 mb-3">
      <label className="form-label" style={{ minWidth: "120px" }}>
        Payment Type <span className="text-danger">*</span>
      </label>
      <Controller
        control={control}
        name="paymentType"
        render={({ field: { onChange, value } }) => (
          <Select
            classNamePrefix="react-select"
            options={paymentType}
            value={paymentType.find((pt) => pt.value === value)}
            onChange={(selected) => onChange(selected?.value)}
            styles={{
              control: (provided) => ({
                ...provided,
                minHeight: '40px',
                width: '237px',
              }),
              menu: (provided) => ({
                ...provided,
                zIndex: 9999,
              }),
            }}
            required
          />
        )}
      />
    </div>
  </div>

  <div className="col-md-4 col-sm-6 col-12">
    <div className="input-blocks d-flex align-items-center gap-2 mb-3">
      <label className="form-label mb-0" style={{ minWidth: "120px" }}>Entry No</label>
      <input
        type="text"
        className="form-control"
        {...register("entrynumber")}
        required
        disabled
      />
    </div>
  </div>

  {/* Row 2 */}
<div className="col-md-4 col-sm-6 col-12">
  <div className="input-blocks d-flex align-items-center gap-2 mb-3">
    <label className="form-label" style={{ minWidth: "120px" }}>
      Supplier Name <span className="text-danger">*</span>
    </label>

    {/* Wrap select and icon in flex container */}
    <div className="d-flex align-items-center gap-2 w-100">
      {/* Select Box */}
      <div style={{ flex: 1 }}>
        <Controller
          control={control}
          name="supplier"
          render={({ field: { onChange, value } }) => (
            <Select
              classNamePrefix="react-select"
              options={supplierData}
              value={supplierData.find((s) => s.value === value) || null}
              onChange={(selected) => onChange(selected?.value || null)}
              styles={{
                control: (provided) => ({
                  ...provided,
                  width: "100%",
                  minHeight: "40px",
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
              }}
              required
            />
          )}
        />
      </div>

      {/* Plus Icon */}
      <div className="add-icon">
        <Link to="#" onClick={() => setModalOpen(true)}>
          <PlusCircle className="feather-plus-circles" />
        </Link>
      </div>
    </div>
  </div>
</div>


  <div className="col-md-4 col-sm-6 col-12">
    <div className="input-blocks d-flex align-items-center gap-2 mb-3">
      <label className="form-label mb-0" style={{ minWidth: "120px" }}>Shipment Term</label>
      <input
        type="text"
        className="form-control"
        {...register("shipmentTerms")}
        onKeyDown={handleKeyDown}
      />
    </div>
  </div>

  <div className="col-md-4 col-sm-6 col-12">
    <div className="input-blocks d-flex align-items-center gap-2 mb-3">
      <label className="form-label" style={{ minWidth: "120px" }}>Due Date</label>
      <div className="input-groupicon calender-input w-100">
        <Calendar className="info-img" />
        <Controller
          control={control}
          name="duedate"
          render={({ field: { onChange, value } }) => (
            <DatePicker
              className="datetimepicker"
              value={value ? dayjs(value) : null}
              format="DD-MM-YYYY"
              onChange={(date) => onChange(date ? date.format("YYYY-MM-DD") : null)}
            />
          )}
        />
      </div>
    </div>
  </div>

  {/* Row 3 - Remarks */}
  <div className="col-12">
    <div className="input-blocks d-flex align-items-center gap-2">
      <label className="form-label" style={{ minWidth: "120px" }}>Remarks</label>
      <input type="text" className="form-control" {...register("remarks")} />
    </div>
  </div>

</div>

                        <div className="table-responsive  no-pagination table-container">
                          <table className="table tablezinds">
                            <thead>
                              <tr>
                                <th className="sticky-header">
                                  Description
                                  <span className="text-danger">*</span>
                                </th>
                                <th className="sticky-header">Item Code</th>{" "}
                                <th className="sticky-header">Unit</th>
                                <th className="sticky-header">
                                  Qty<span className="text-danger">*</span>
                                </th>
                                <th className="sticky-header">
                                  Price <span className="text-danger">*</span>
                                </th>
                                {/* <th className="sticky-header">MRP </th> */}
                                <th className="sticky-header">FOC</th>
                                <th className="sticky-header">Gross</th>
                                <th className="sticky-header">Disc %</th>
                                <th className="sticky-header">
                                  Disc Amt
                                </th>
                                {branchsettings?.disableTaxInSale == false && (
                                  <th className="sticky-header">Tax %</th>
                                )}
                                {branchsettings?.disableTaxInSale == false && (
                                  <th className="sticky-header">Tax Amt</th>
                                )}
                                <th className="sticky-header">Net Amt</th>
                                <th className="sticky-header"></th>
                              </tr>
                            </thead>
                            <tbody>
                              {fields?.map((field, index) => {
                                return (
                                  <tr key={field.id}>
                                    <td data-label="Description">
                                      <Controller
                                        control={control}
                                        name={`items[${index}].product`}
                                        rules={{
                                          required: "Product is required",
                                          validate: (value) => {
                                            const selectedProducts = watch(
                                              "items"
                                            )?.map((item) => item.product); // Get all selected products
                                            const isDuplicate =
                                              selectedProducts?.filter(
                                                (product) => product === value
                                              )?.length > 1;
                                            return (
                                              !isDuplicate ||
                                              "Duplicate product selected!"
                                            );
                                          },
                                        }}
                                        render={({
                                          field: { onChange, value, ref },
                                        }) => (
                                          <Select
                                            ref={selectRef}
                                            classNamePrefix="react-select"
                                            options={products}
                                            isSearchable={true}
                                            value={
                                              products?.find(
                                                (option) =>
                                                  option.value === value
                                              ) || null
                                            }
                                            onChange={(selectedOption) => {
                                              onChange(
                                                selectedOption
                                                  ? selectedOption.value
                                                  : null
                                              );
                                              handleEachProductfetch(
                                                selectedOption,
                                                index
                                              );
                                            }}
                                            styles={{
                                              menu: (provided) => ({
                                                ...provided,
                                                zIndex: 9999,
                                                position: "relative",
                                              }),
                                            }}
                                          />
                                        )}
                                      />
                                      {errors.items &&
                                        errors.items[index]?.product && (
                                          <span className="text-danger small">
                                            {
                                              errors.items[index].product
                                                .message
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td data-label="Item Code">
                                      <input
                                        type="text"
                                        className="form-control"
                                        {...register(`items[${index}].code`)}
                                        disabled
                                      />
                                    </td>
                                    {/* <td>
                                      <Controller
                                        control={control}
                                        name={`items[${index}].unit`}
                                        render={({
                                          field: { onChange, value },
                                        }) => (
                                          <Select
                                            classNamePrefix="react-select"
                                            options={unitData}
                                            value={unitData?.find(
                                              (option) => option.value === value
                                            )}
                                            onChange={(selectedOption) => {
                                              onChange(selectedOption.value);
                                            }}
                                            isDisabled={true}
                                          />
                                        )}
                                      />
                                    </td> */}
  <td>
  <input
    type="text"
    className="form-control"
    value={
      unitData?.find(
        (option) => option.value === watch(`items[${index}].unit`)
      )?.label || ""
    }
    readOnly
  />
</td>


                                    <td data-label="Quantity">
                                      <input
                                        type="text"
                                        className="form-control"
                                        {...register(
                                          `items[${index}].quantity`,
                                          {
                                            required: "Quantity is required",
                                            validate: (value) =>
                                              (!isNaN(value) && value > 0) ||
                                              "Quantity must be a positive number",
                                          }
                                        )}
                                      />
                                      {errors.items &&
                                        errors.items[index]?.quantity && (
                                          <span className="text-danger small">
                                            {
                                              errors.items[index].quantity
                                                .message
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td data-label="Price">
                                      <input
                                        type="text"
                                        className="form-control"
                                        {...register(`items[${index}].price`, {
                                          required: "Price is required",
                                          validate: (value) =>
                                            (!isNaN(value) && value > 0) ||
                                            "Price must be a positive number",
                                        })}
                                      />
                                      {errors.items &&
                                        errors.items[index]?.price && (
                                          <span className="text-danger small">
                                            {errors.items[index].price.message}
                                          </span>
                                        )}
                                    </td>
                                    {/* <td>
                                      <input
                                        type="text"
                                        className="form-control"
                                        {...register(`items[${index}].mrp`, {
                                          validate: (value) =>
                                            (!isNaN(value) && value >= 0) ||
                                            "MRP must be zero or more",
                                        })}
                                      />
                                      {errors.items &&
                                        errors.items[index]?.mrp && (
                                          <span className="text-danger small">
                                            {errors.items[index].mrp.message}
                                          </span>
                                        )}
                                    </td> */}
                                    <td>
                                      <input
                                        type="text"
                                        className="form-control"
                                        {...register(`items[${index}].foc`, {
                                          validate: (value) =>
                                            (!isNaN(value) && value >= 0) ||
                                            "FOC must be zero or more",
                                        })}
                                      />
                                      {errors.items &&
                                        errors.items[index]?.foc && (
                                          <span className="text-danger small">
                                            {errors.items[index].foc.message}
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <input
                                        type="text"
                                        className="form-control"
                                        {...register(`items[${index}].gross`)}
                                        disabled
                                      />
                                    </td>
                                    <td>
                                      <Controller
                                        control={control}
                                        name={`items[${index}].discountPercentage`}
                                        render={({
                                          field: { onChange, value },
                                        }) => (
                                          <Select
                                            classNamePrefix="react-select"
                                              placeholder="select"
                                            options={discountData}
                                            isClearable
                                            value={
                                              discountData?.find(
                                                (option) =>
                                                  option.value === value
                                              ) ?? null
                                            }
                                            onChange={(selectedOption) =>
                                              onChange(
                                                selectedOption
                                                  ? selectedOption.value
                                                  : null
                                              )
                                            }
                                            styles={{
                                              menu: (provided) => ({
                                                ...provided,
                                                zIndex: 9999,
                                                position: "relative",
                                              }),
                                            }}
                                          />
                                        )}
                                      />
                                    </td>
                                    <td data-label="Discount Amount">
                                      <input
                                        type="text"
                                        className="form-control"
                                        {...register(
                                          `items[${index}].discountAmount`
                                        )}
                                        disabled
                                      />
                                    </td>
                                    {branchsettings?.disableTaxInSale ==
                                      false && (
                                      <td >
                                        <Controller
                                          control={control}
                                          name={`items[${index}].taxPercentage`}
                                          render={({
                                            field: { onChange, value },
                                          }) => (
                                            <Select
                                              classNamePrefix="react-select"
                                              options={taxData}
                                              placeholder="select"
                                              isClearable
                                              value={
                                                taxData?.find(
                                                  (option) =>
                                                    option.value === value
                                                ) || null
                                              }
                                              onChange={(selectedOption) => {
                                                onChange(
                                                  selectedOption
                                                    ? selectedOption.value
                                                    : null
                                                );
                                              }}
                                              styles={{
                                                menu: (provided) => ({
                                                  ...provided,
                                                  zIndex: 9999,
                                                  position: "relative",
                                                }),
                                              }}
                                            />
                                          )}
                                        />
                                      </td>
                                    )}
                                    {branchsettings?.disableTaxInSale ==
                                      false && (
                                      <td data-label="Tax Amount">
                                        <input
                                          type="text"
                                          className="form-control"
                                          {...register(
                                            `items[${index}].taxAmount`
                                          )}
                                          disabled
                                        />
                                      </td>
                                    )}
                                    <td data-label="Net Amount">
                                      <input
                                        type="text"
                                        className="form-control"
                                        {...register(
                                          `items[${index}].netTotal`
                                        )}
                                        disabled
                                      />
                                    </td>
                                    <td>
                                      <Link
                                        className="confirm-text p-2"
                                        onClick={() => handleRemove(index)}
                                      >
                                        <i
                                          data-feather="trash-2"
                                          className="feather-trash-2"
                                        ></i>
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>

                        <div>
                          <div className="col-lg-2 col-sm-2 col-2 ps-0 ">
                            <button
                              className=" btn btn-dark add-icon tab  mt-3 "
                              type="button"
                              onClick={handleAddRow}
                            >
                              <PlusCircle className="feather-plus-circles" />
                            </button>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className=" col-4 ">
                            <div className="input-blocks d-flex align-items-center gap-2">
                              <label>Addition</label>
                              <div className="input-groupicon select-code">
                                <input
                                  type="number"
                                  step="any"
                                  min={0}
                                  className="form-control p-2"
                                  defaultValue={0}
                                  {...register(`addition`)}
                                />
                                {errors.addition && (
                                  <span className="text-danger small mt-1">
                                    {errors.addition.message}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className=" col-4 ">
                            <div className="input-blocks  d-flex align-items-center gap-2">
                              <label>Discount</label>
                              <div className="input-groupicon select-code">
                                <input
                                  type="number"
                                  step="any"
                                  min={0}
                                  className="form-control p-2"
                                  defaultValue={0}
                                  {...register(`subtraction`, {
                                    validate: (value) => {
                                      const discount = safeNumber(value);
                                      const totalNetAfterDiscount =
                                        totalNet - discount;
                                      if (discount < 0) {
                                        return "Discount value should not be negative.";
                                      } else if (totalNetAfterDiscount < 0) {
                                        return "Please enter a discount value that does not exceed the Net Total.";
                                      }
                                      return true;
                                    },
                                  })}
                                />
                                {errors.subtraction && (
                                  <span className="text-danger small mt-1">
                                    {errors.subtraction.message}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className=" col-4 ">
                            <div className="input-blocks d-flex align-items-center gap-2">
                              <label>Round Off</label>
                              <div className="input-groupicon select-code">
                                <input
                                  type="number"
                                  step="any"
                                  min={0}
                                  className="form-control p-2"
                                  defaultValue={0}
                                  {...register(`round`, {
                                    validate: (value) => {
                                      console.log(
                                        "Round value entered:",
                                        value
                                      ); // Check entered value
                                      const round = safeNumber(value);
                                      const totalNetAfterRound =
                                        totalNet - round;
                                      return (
                                        totalNetAfterRound >= 0 ||
                                        "Please enter a round-off value that does not exceed Net Total."
                                      );
                                    },
                                  })}
                                />
                                {errors.round && (
                                  <span className="text-danger small mt-1">
                                    {errors.round.message}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-4 ms-auto">
                            <div className="total-order w-100 max-widthauto m-auto mb-4">
                              <ul>
                                <li>
                                  <h4>Gross</h4>
                                  <h5>{totalGross?.toFixed(decimalpoints)}</h5>
                                </li>
                                <li>
                                  <h4>Discount</h4>
                                  <h5>
                                    {totalDiscount?.toFixed(decimalpoints)}
                                  </h5>
                                </li>
                                <li>
                                  <h4>Tax Total</h4>
                                  <h5> {totalTax?.toFixed(decimalpoints)}</h5>
                                </li>
                                <li>
                                  <h4>Net Total</h4>
                                  <h5> {totalNet?.toFixed(decimalpoints)}</h5>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="col-lg-12 text-end">
                            <button
                              type="submit"
                              className="btn btn-cancel add-cancel me-3"
                              onClick={() => setPrintAfterSubmit(true)} // 👈 set flag before submit
                            >
                              Save & Print
                            </button>
                            <button
                              type="button"
                              className="btn btn-cancel add-cancel me-3"
                              onClick={() => resetmodal()}
                            >
                              Reset
                            </button>
                            <button
                              className="btn btn-submit add-sale"
                              type="submit"
                            >
                              Submit
                            </button>{" "}
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {modalOpen && (
          <SupplierModal
            mode="add"
            data={{}}
            handleClose={() => setModalOpen(false)}
            handleRefresh={() => {}}
          />
        )}
      </div>
    </>
  );
};
export default PurchaseOrderModal;
